import {useQuery} from 'react-query'
import {useLocation} from 'react-router-dom'
import api from '..'
import {TApiPage, TApiResponse} from '../../types/api'
import {getErrorToast} from '../../constructor/helpers/toasts'

type UsePageParams = {
    page?: string | null
    context?: Record<string, any>
}

const usePage = (params?: UsePageParams) => {
    const {pathname} = useLocation()
    const resolvedPath = (params?.page ?? pathname.slice(1)) || ''

    const fetchKey = ['page', resolvedPath, params?.context]
    const fetchFunction = () =>
        api<TApiPage>(
            'pages',
            'get',
            params?.context ? {page: resolvedPath, context: params.context} : {page: resolvedPath}
        )

    const hookConfiguration = {
        retry: false,
        refetchOnWindowFocus: false,
        enabled: Boolean(resolvedPath),
        select: (response: TApiResponse<TApiPage>) => {
            return {
                modules: response.data,
                analytics: response.detail?.pageAnalytics ?? null,
            }
        },
        onError: (error: {message: string}) => getErrorToast(error.message),
    }
    const {isLoading, isFetching, error, data, refetch} = useQuery(
        fetchKey,
        fetchFunction,
        hookConfiguration
    )
    return {isLoading, isFetching, error, data, refetch}
}

export default usePage
